import CourseGroupCoachingForm from '@/views/App/Course/GroupCoaching/Form.vue';
import CourseGroupCoachingList from '@/views/App/Course/GroupCoaching/List.vue';

const routesCourseGroupCoaching = [
    {
        path: 'list',
        name: 'courseGroupCoachingList',
        component: CourseGroupCoachingList
    },
    {
        path: 'form/:id?',
        name: 'courseGroupCoachingForm',
        component: CourseGroupCoachingForm
    },
];

export default routesCourseGroupCoaching;